/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiType } from '@squiz/dxp-ai-client';
import { BUTTON_FORMAT_SOFT, BUTTON_THEME_DEFAULT, EmptyState, ICON_AUTO_FIX_HIGH_WITH_MENU } from '@squiz/sds';
import React from 'react';
import { CreateToolDialog } from '../../CreateToolDialog/CreateToolDialog';

type AiDataListEmptyStateProps = {
  type: AiType;
};

export const AiDataListEmptyState = (props: AiDataListEmptyStateProps): JSX.Element => {
  return (
    <EmptyState caption={'There are no available tools.'} isLite svg={ICON_AUTO_FIX_HIGH_WITH_MENU}>
      <CreateToolDialog
        buttonProps={{
          format: BUTTON_FORMAT_SOFT,
          icon: undefined,
          theme: BUTTON_THEME_DEFAULT,
        }}
        type={props.type}
      ></CreateToolDialog>
    </EmptyState>
  );
};
